import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

export interface DataSource {
  name: string;
  date: string;
  /** i18n key for grid-step suffix; omit when the source has no published step. */
  gridStepKey?: string;
}

@Component({
  selector: 'app-data-sources',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ],
  templateUrl: './data-sources.component.html',
  styleUrls: ['./data-sources.component.scss']
})
export class DataSourcesComponent {
  @Input() sources: DataSource[] = [];
}
